import KeyboardTabIcon from "@mui/icons-material/KeyboardTab";
import BatteryStdIcon from "@mui/icons-material/BatteryStd";
import BoltIcon from "@mui/icons-material/Bolt";
import AutorenewIcon from "@mui/icons-material/Autorenew";

export const OVERRIDE_MODES = Object.freeze({
  CONTROL_LIMIT: {
    label: "Control limit",
    value: "CONTROL_LIMIT",
    enabled: true,
    icon: ({ ...props }) => <AutorenewIcon {...props} />,
  },
  GRID: { label: "Grid", value: "GRID", enabled: true, icon: ({ ...props }) => <BoltIcon {...props} /> },
  FLEX: { label: "Flex", value: "FLEX", enabled: true, icon: ({ ...props }) => <BatteryStdIcon {...props} /> },
  CURTAILMENT_PRODUCTION: {
    label: "Curtail production",
    value: "CURTAILMENT_PRODUCTION",
    enabled: true,
    icon: ({ ...props }) => <KeyboardTabIcon {...props} />,
  },
  CURTAILMENT_CONSUMPTION: {
    label: "Curtail consumption",
    value: "CURTAILMENT_CONSUMPTION",
    enabled: false,
    icon: ({ ...props }) => <KeyboardTabIcon {...props} />,
  },
  CURTAILMENT_GRID_MIN: {
    label: "Curtail grid min",
    value: "CURTAILMENT_GRID_MIN",
    enabled: true,
    icon: ({ ...props }) => <KeyboardTabIcon {...props} />,
  },
  GRID_REACTIVE: {
    label: "Grid reactive",
    value: "GRID_POWER",
    enabled: false,
    icon: ({ ...props }) => <BoltIcon {...props} />,
  }, // This is ugly because it ends on REACTIVE
  FLEX_REACTIVE: {
    label: "Flex reactive",
    value: "FLEX_POWER",
    enabled: false,
    icon: ({ ...props }) => <BatteryStdIcon {...props} />,
  },
});

export const OVERRIDE_SOURCES = Object.freeze({
  COMMISSIONING: "commissioning_device",
  DEV: "dev",
  PLATFORM: "platform",
  DATABASE: "database",
});

export const POS_ONLY_OVERRIDES = [
  OVERRIDE_MODES.CONTROL_LIMIT.value,
  OVERRIDE_MODES.CURTAILMENT_CONSUMPTION.value,
  OVERRIDE_MODES.CURTAILMENT_PRODUCTION.value,
  OVERRIDE_MODES.CURTAILMENT_GRID_MIN.value,
];
export const NO_TARGET_MODES = [OVERRIDE_MODES.GRID.value];

export const OVERRIDE_TYPES = Object.freeze({
  FRACTION: { label: "Fraction", value: "FRACTION", enabled: true },
  POWER: { label: "Power", value: "POWER", enabled: true },
});

export function getFullOverrideName(mode, type) {
  if (!getOverrideModeValues().includes(mode)) {
    throw `Invalid override mode: ${mode}, possible values are ${getOverrideModeValues()}`;
  } else if (!getOverrideTypeValues().includes(type)) {
    throw `Invalid override type: ${type}, possible values are ${getOverrideTypeValues()}`;
  }
  return mode + "_" + type;
}

export function getModeLabelByValue(value) {
  return getOverrideModeByValue(value)?.label;
}

export function getModeValueByLabel(label) {
  return getValueByLabel(OVERRIDE_MODES, label);
}

export function getTypeLabelByValue(value) {
  return getOverrideTypeByValue(value)?.label;
}

export function getTypeValueByLabel(label) {
  return getValueByLabel(OVERRIDE_TYPES, label);
}

// dict = {KEY: {label: x, value: a}}
export function getOverrideModeByValue(value) {
  for (const key in OVERRIDE_MODES) {
    if (OVERRIDE_MODES[key].value === value) {
      return OVERRIDE_MODES[key];
    }
  }
  return undefined;
}

export function getOverrideTypeByValue(value) {
  for (const key in OVERRIDE_TYPES) {
    if (OVERRIDE_TYPES[key].value === value) {
      return OVERRIDE_TYPES[key];
    }
  }
  return undefined;
}

// GENERAL SOLUTION FOR THE TWO FUNCTION ABOVE
// export function getByValue(dict, value, key=null) {
//     for (const obj in dict) {
//         if (dict[obj].value === value) {
//             if (obj !== null) {
//                 return dict[obj][key];
//             }
//             else {
//                 return dict[obj]
//             }
//         }
//     }
//     return undefined;
// }

// dict = {OBJ: {label: x, value: a}}
function getValueByLabel(dict, label) {
  for (const key in dict) {
    if (dict[key].label === label) {
      return dict[key].value;
    }
  }
  return undefined;
}

export function getOverrideModeValues() {
  return Object.values(OVERRIDE_MODES)
    .filter((obj) => obj.enabled)
    .map((obj) => obj.value);
}

export function getOverrideTypeValues() {
  return Object.values(OVERRIDE_TYPES)
    .filter((obj) => obj.enabled)
    .map((obj) => obj.value);
}

export function getOverrideModeLabels() {
  return Object.values(OVERRIDE_MODES)
    .filter((obj) => obj.enabled)
    .map((obj) => obj.label);
}

export function getOverrideTypeLabels() {
  return Object.values(OVERRIDE_TYPES)
    .filter((obj) => obj.enabled)
    .map((obj) => obj.label);
}
